import {DataValueType} from "../kiwis/data-value-type";

export const isArray = (() => Array.isArray || (<T>(x: any): x is T[] => x && typeof x.length === "number"))();

export class UnitsUtils {
    constructor() {}

    static unitLabel(unitSymbol: string, type: DataValueType) {
        if (unitSymbol === "cumec") {
            return "m3/s";
        }
        if (type === DataValueType.Absolute && unitSymbol === "m") {
            return "m ü. Meer";
        }
        return unitSymbol;
    }

    static isNumeric(val: any): val is number | string {
        // parseFloat NaNs numeric-cast false positives (null|true|false|"")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        // adding 1 corrects loss of precision from parseFloat (#15100)
        return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
    }
}

